'use strict';

var React = require('react');

var SvgPackageReturnedIcon = function SvgPackageReturnedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 10.75v-2.75h-10v6.75c0 .138.112.25.25.25h4c.414 0 .75.336.75.75s-.336.75-.75.75h-4c-.966 0-1.75-.784-1.75-1.75v-6.863c0-.57.177-1.125.506-1.59l1.309-1.848c.421-.595 1.106-.949 1.836-.949h5.796c.753 0 1.455.376 1.872 1.002l1.22 1.828c.3.452.461.983.461 1.526v2.894c0 .414-.336.75-.75.75s-.75-.336-.75-.75Zm-8.461-5.434c.14-.198.368-.316.612-.316h2.099v1.5h-3.55l.839-1.184Zm7.81 1.184h-3.599v-1.5h2.197c.251 0 .485.125.624.334l.778 1.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10c0-.552.448-1 1-1h4c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1v-3Zm1.5.5v2h3v-2h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v.5c0 .966-.784 1.75-1.75 1.75h-.94l.22-.22c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-1.5 1.5c-.293.293-.293.767 0 1.06l1.5 1.5c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-.22-.22h.94c1.795 0 3.25-1.455 3.25-3.25v-.5Z"
  }));
};
SvgPackageReturnedIcon.displayName = "PackageReturnedIcon";

exports.SvgPackageReturnedIcon = SvgPackageReturnedIcon;
